import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-google-privacy-agreement',
  templateUrl: './google-privacy-agreement.component.html',
  styleUrls: ['./google-privacy-agreement.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class GooglePrivacyAgreementComponent {

  @Input() applyLineBreaks: boolean = false;
  
  constructor() { }

}
